module.exports = __webpack_public_path__ + "img/home3.aa544df6.png";